"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbnailBroken = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ThumbnailBroken = function ThumbnailBroken(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.default, _extends({}, props, {
    viewBox: "0 0 80 80",
    fill: "none",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "79",
    height: "79",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thm-broken-clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 39.1562L53.5 43.6562V50.4766C53.5 51.2734 53.1953 51.9766 52.5859 52.5859C51.9766 53.1953 51.2734 53.5 50.4766 53.5H29.5234C28.7266 53.5 28.0234 53.1953 27.4141 52.5859C26.8047 51.9766 26.5 51.2734 26.5 50.4766V40.6328L31 45.1328L36.9766 39.0859L43.0234 45.1328L49 39.1562ZM53.5 29.5234V39.3672L49 34.8672L43.0234 40.9141L36.9766 34.8672L31 40.9141L26.5 36.3438V29.5234C26.5 28.7266 26.8047 28.0234 27.4141 27.4141C28.0234 26.8047 28.7266 26.5 29.5234 26.5H50.4766C51.2734 26.5 51.9766 26.8047 52.5859 27.4141C53.1953 28.0234 53.5 28.7266 53.5 29.5234Z",
    fill: "#D4D4D5"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "79",
    height: "79",
    stroke: "#D4D4D5"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thm-broken-clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "79",
    height: "80",
    fill: "white",
    transform: "translate(1)"
  }))));
};
exports.ThumbnailBroken = ThumbnailBroken;